/**
* @Author: zachalam
* @Date:   2017-03-01T14:32:02-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-03-01T14:32:02-08:00
*/




let initialState = {
  item: {},
  isFetching: false
};

const convo = (state = initialState, action) => {
  switch(action.type) {
    case 'REQUEST_CONVO':
      return {
        ...state,
        isFetching: true
      }

    case 'STORE_CONVO':
      return {
        ...state,
        isFetching: false,
        item: {
          ...action.payload
        }
      }
      
    case 'CLEAR_CONVO':
      return {
        ...state,
        item: {},
        isFetching: false
      }

    case 'STORE_MESSAGE':
      // add message to current convo.
      var newState = Object.assign({}, state);
      newState.item.messages.data.push(action.payload);
      return newState;

    default:
      return state;
  }
}



export default convo;



// WEBPACK FOOTER //
// ./src/reducers/convo.js